import { createContext, useContext } from 'react';

type ToastContextValue = {
  showCopiedToast: () => void;
  showCopyFailedToast: () => void;
};

export const ToastContext = createContext<ToastContextValue>({
  showCopiedToast: () => {},
  showCopyFailedToast: () => {},
});

export const useToast = () => useContext(ToastContext);
